import React from "react";
import { Dialog, DialogContent, Button } from "@mui/material";
import "../css/OvertimeDialog.css";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { OVERTIME_BASE_MESSAGE, TIME_FORMAT } from "../../utils/constants";

dayjs.extend(utc);

const OvertimeDialog = ({
  flightDetails,
  editedFlightDetails,
  isEditScreen = false,
  origin,
  destination,
  open,
  onClose,
  onAccept,
}) => {
  const getOvertimeMessage = () => {
    const departureOpeningTime = dayjs(origin?.openingTime, "HH:mmZ").format(
      TIME_FORMAT
    );

    const arrivalClosingTime = dayjs(destination?.closingTime, "HH:mmZ").format(
      TIME_FORMAT
    );

    const arrivingTime = dayjs(flightDetails?.arrivalTime).format(TIME_FORMAT);
    const departureTime = dayjs(flightDetails?.departureTime).format(
      TIME_FORMAT
    );

    const getArrivalOvertimeMessage = () =>
      `This airport closes at ${arrivalClosingTime}. Do you want to request after hour from ${arrivalClosingTime} to ${arrivingTime}?`;

    const getDepartureOvertimeMessage = () =>
      `This airport opens at ${departureOpeningTime}. Do you want to request after hour from ${departureTime} to ${departureOpeningTime}?`;

    if (
      isEditScreen
        ? editedFlightDetails?.requiresArrivalOvertime &&
          editedFlightDetails?.requiresDepartureOvertime
        : flightDetails?.requiresArrivalOvertime &&
          flightDetails?.requiresDepartureOvertime
    ) {
      return `${getArrivalOvertimeMessage()} ${getDepartureOvertimeMessage()} ${OVERTIME_BASE_MESSAGE}`;
    }

    if (
      isEditScreen
        ? editedFlightDetails?.requiresArrivalOvertime
        : flightDetails?.requiresArrivalOvertime
    ) {
      return `${getArrivalOvertimeMessage()} ${OVERTIME_BASE_MESSAGE}`;
    }

    if (
      isEditScreen
        ? editedFlightDetails?.requiresDepartureOvertime
        : flightDetails?.requiresDepartureOvertime
    ) {
      return `${getDepartureOvertimeMessage()} ${OVERTIME_BASE_MESSAGE}`;
    }

    return `Do you want to request after hour? ${OVERTIME_BASE_MESSAGE}`;
  };

  return (
    <Dialog
      open={open ?? false}
      onClose={onClose}
      PaperProps={{
        className: "overtime-dialog-container",
      }}
    >
      <DialogContent>
        <div className="overtime-dialog-content">
          <div className="overtime-dialog-title-container">
            <div className="overtime-dialog-title">{getOvertimeMessage()}</div>
          </div>
          <Button variant="contained" className="change" onClick={onClose}>
            Change
          </Button>
          <Button variant="contained" className="accept" onClick={onAccept}>
            Accept and Proceed
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default OvertimeDialog;
